import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { Popover } from 'antd';
import ToolBtn from '../ToolBtn';
import { ToolConfig, ToolTye } from '@/components/Note/utils';
import ShapeSelect, { ShapeSelectValue } from '../ShapeSelect';
import { getFormatMessage } from '@/utils/locale';
interface ShapeProps {
  value: ShapeSelectValue;
  onChange: (value: ShapeSelectValue) => void;
  activeType: ToolTye.LINE_ARROW | ToolTye.LINE | ToolTye.RECT | ToolTye.ELLIPSE;
}
export const ToolIconMap = {
  [ToolTye.LINE_ARROW]: 'icon-arrow_shot_little_1',
  [ToolTye.LINE]: 'icon-line',
  [ToolTye.RECT]: 'icon-square',
  [ToolTye.ELLIPSE]: 'icon-circle',
};

export const ToolTitleMap = {
  [ToolTye.LINE_ARROW]: getFormatMessage('arrow'),
  [ToolTye.LINE]: getFormatMessage('line'),
  [ToolTye.RECT]: getFormatMessage('rectangle'),
  [ToolTye.ELLIPSE]: getFormatMessage('oval'),
};
const list = [ToolTye.LINE_ARROW, ToolTye.LINE, ToolTye.RECT, ToolTye.ELLIPSE];

const Shape: React.FC<ShapeProps> = (props) => {
  const { value, activeType, onChange } = props;

  const { formatMessage } = useIntl();
  const [popOverOpen, setPopOverOpen] = React.useState(false);
  const onPopoverOpen = (visible: boolean) => {
    setPopOverOpen(visible);
  };

  const name = useMemo(() => {
    if (list.includes(value.type)) {
      return ToolIconMap[value.type as keyof typeof ToolIconMap];
    }
    return ToolIconMap[activeType];
  }, [value, activeType]);

  const title = useMemo(() => {
    if (list.includes(value.type)) {
      return ToolTitleMap[value.type as keyof typeof ToolTitleMap];
    }
    return ToolTitleMap[activeType];
  }, [value, activeType]);

  return (
    <Popover
      trigger="click"
      placement="right"
      overlayClassName="oj7YZbAO5p"
      content={<ShapeSelect value={value} onChange={onChange}></ShapeSelect>}
      align={{ offset: [-2] }}
      onOpenChange={onPopoverOpen}
    >
      <ToolBtn
        name={name}
        active={list.includes(value.type)}
        title={popOverOpen ? '' : title}
        onClick={() => {
          // 点击菜单图标 就去设置一下默认工具
          // 如果当前值不在图形类型 返回上一次的内容
          if (list.includes(value.type)) {
            onChange({ type: value.type, pen_width: value.pen_width });
          } else {
            onChange({ type: activeType, pen_width: value.pen_width });
          }
        }}
      ></ToolBtn>
    </Popover>
  );
};

export default Shape;
